import { render, staticRenderFns } from "./CoozzyLocationIcon.vue?vue&type=template&id=d8a5cd14&scoped=true"
import script from "./CoozzyLocationIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyLocationIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyLocationIcon.vue?vue&type=style&index=0&id=d8a5cd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a5cd14",
  null
  
)

export default component.exports